// tslint:disable
/**
 * Document generator api
 * Generate documents from templates
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as globalImportUrl from 'url';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { TemplateFile } from '../models';
import { TemplateFileCreate } from '../models';
import { TemplateFileEdit } from '../models';
/**
 * TemplateFilesApi - axios parameter creator
 * @export
 */
export const TemplateFilesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {TemplateFileCreate} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTemplateFile(body: TemplateFileCreate, options: any = {}): RequestArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createTemplateFile.');
            }
            const localVarPath = `/document-generator/template-files`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTemplateFile(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteTemplateFile.');
            }
            const localVarPath = `/document-generator/template-file/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {TemplateFileEdit} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editTemplateFile(id: string, body: TemplateFileEdit, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling editTemplateFile.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling editTemplateFile.');
            }
            const localVarPath = `/document-generator/template-file/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {'act' | 'bill' | 'contract' | 'education-protocol' | 'enrollment-order' | 'expulsion-order' | 'final-document'} [context] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTemplateFiles(companyId: string, context?: 'act' | 'bill' | 'contract' | 'education-protocol' | 'enrollment-order' | 'expulsion-order' | 'final-document', options: any = {}): RequestArgs {
            // verify required parameter 'companyId' is not null or undefined
            if (companyId === null || companyId === undefined) {
                throw new RequiredError('companyId','Required parameter companyId was null or undefined when calling listTemplateFiles.');
            }
            const localVarPath = `/document-generator/template-files`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (context !== undefined) {
                localVarQueryParameter['context'] = context;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TemplateFilesApi - functional programming interface
 * @export
 */
export const TemplateFilesApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {TemplateFileCreate} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTemplateFile(body: TemplateFileCreate, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TemplateFile> {
            const localVarAxiosArgs = TemplateFilesApiAxiosParamCreator(configuration).createTemplateFile(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTemplateFile(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = TemplateFilesApiAxiosParamCreator(configuration).deleteTemplateFile(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {TemplateFileEdit} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editTemplateFile(id: string, body: TemplateFileEdit, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TemplateFile> {
            const localVarAxiosArgs = TemplateFilesApiAxiosParamCreator(configuration).editTemplateFile(id, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {'act' | 'bill' | 'contract' | 'education-protocol' | 'enrollment-order' | 'expulsion-order' | 'final-document'} [context] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTemplateFiles(companyId: string, context?: 'act' | 'bill' | 'contract' | 'education-protocol' | 'enrollment-order' | 'expulsion-order' | 'final-document', options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TemplateFile>> {
            const localVarAxiosArgs = TemplateFilesApiAxiosParamCreator(configuration).listTemplateFiles(companyId, context, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * TemplateFilesApi - factory interface
 * @export
 */
export const TemplateFilesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {TemplateFileCreate} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTemplateFile(body: TemplateFileCreate, options?: any) {
            return TemplateFilesApiFp(configuration).createTemplateFile(body, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTemplateFile(id: string, options?: any) {
            return TemplateFilesApiFp(configuration).deleteTemplateFile(id, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {TemplateFileEdit} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editTemplateFile(id: string, body: TemplateFileEdit, options?: any) {
            return TemplateFilesApiFp(configuration).editTemplateFile(id, body, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {'act' | 'bill' | 'contract' | 'education-protocol' | 'enrollment-order' | 'expulsion-order' | 'final-document'} [context] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTemplateFiles(companyId: string, context?: 'act' | 'bill' | 'contract' | 'education-protocol' | 'enrollment-order' | 'expulsion-order' | 'final-document', options?: any) {
            return TemplateFilesApiFp(configuration).listTemplateFiles(companyId, context, options)(axios, basePath);
        },
    };
};

/**
 * TemplateFilesApi - object-oriented interface
 * @export
 * @class TemplateFilesApi
 * @extends {BaseAPI}
 */
export class TemplateFilesApi extends BaseAPI {
    /**
     * 
     * @param {TemplateFileCreate} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplateFilesApi
     */
    public createTemplateFile(body: TemplateFileCreate, options?: any) {
        return TemplateFilesApiFp(this.configuration).createTemplateFile(body, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplateFilesApi
     */
    public deleteTemplateFile(id: string, options?: any) {
        return TemplateFilesApiFp(this.configuration).deleteTemplateFile(id, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} id 
     * @param {TemplateFileEdit} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplateFilesApi
     */
    public editTemplateFile(id: string, body: TemplateFileEdit, options?: any) {
        return TemplateFilesApiFp(this.configuration).editTemplateFile(id, body, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} companyId 
     * @param {'act' | 'bill' | 'contract' | 'education-protocol' | 'enrollment-order' | 'expulsion-order' | 'final-document'} [context] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplateFilesApi
     */
    public listTemplateFiles(companyId: string, context?: 'act' | 'bill' | 'contract' | 'education-protocol' | 'enrollment-order' | 'expulsion-order' | 'final-document', options?: any) {
        return TemplateFilesApiFp(this.configuration).listTemplateFiles(companyId, context, options)(this.axios, this.basePath);
    }

}
